<template>
    <div>
        <Pivot :statisticData="statisticData" :filter-default-values="filterDefaultValues" :filters="filters" :rows="rows" :values="values" title="Services"></Pivot>
    </div>
</template>

<script>
import axios from 'axios'
import Pivot from '../../components/sandoz/Pivot.vue'

export default {
    
    data: () => ({
        statisticData: [],
        filters: [
            'language',
            'contract_status',
            'line_status',
            'year',
            'type',
            'product_group',
            'responsible_sales_person',
            'region'
        ],
        rows: [
            'language',
            'service_name'
        ],
        values: [
            {
                field: 'quantity',
                function: 'sum'                
            },
            {
                field: 'contract_no',
                function: 'count_unique'
            }           
        ],
        filterDefaultValues: [
            {
                year: 2022
            }
        ]         
    }),

    components: {
        Pivot
    },

    mounted() {
        axios.get('/api/sandoz/statistics/services').then((response) => {
            this.statisticData = response.data
        })
    }
}
</script>
